'use client';

import React, { useEffect } from 'react';
import { Tabs, TabsTrigger, TabsList, TabsContent } from '@/components/ui/tabs';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { ArrowLeftRight, Edit2 } from 'lucide-react';
import { IoFunnel } from 'react-icons/io5';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import CityPicker from '@/components/picker/CityPicker';
import DatePicker from '@/components/picker/DatePicker';
import ClassPicker from '@/components/picker/ClassPicker';
import FlightList from '@/components/list/flightlist/FlightList';
// import { FlightListSkeleton } from '@/components/skeleton/FlightListSkelton';
import FareCalender from '@/components/list/flightlist/FareCalender';
import Filter from '@/components/filter/filter';
// import { useTranslations } from '@/lib/i18n';
import { useFlightSearchApi } from '@/hooks/useFlightSearchAPi';
import SelectedFlightInfo from '@/components/SelectedFlightInfo';
import { useSelector, useDispatch } from 'react-redux';
import {
  resetFilter,
  storeData,
  storeReturnData,
} from '@flysync/shared-redux/slices/filterSlice';
import {
  updateField,
  updateReviewData,
  updateFareType,
  updatePassenger,
  isLoader as setIsLoading,
} from '@flysync/shared-redux/slices/flightSearchSlice';
import { addDays, format, isValid, parse, parseISO } from 'date-fns';
import FlightUpIcon from '@/assets/icon/flight-up';
import FlightDownIcon from '@/assets/icon/flight-down';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog';
import { FlightLoader } from '../loader';
import { config } from '@/config';

// type TabTypes = 'ONE_WAY' | 'MULTI_CITY' | 'ROUND_TRIP';

function FlightListing() {
  // const t = useTranslations('FlightListPage');

  const trackApiCall = React.useRef(false);
  const dispatch = useDispatch();
  const state = useSelector(
    (state: { flightSearch: any }) => state.flightSearch,
  );
  const { performFlightSearch, searchResults, isLoading } =
    useFlightSearchApi();

  // Add refs for pickers
  const originPickerRef = React.useRef<HTMLDivElement>(null);
  const destinationPickerRef = React.useRef<HTMLDivElement>(null);
  const fromDatePickerRef = React.useRef<HTMLDivElement>(null);
  const returnDatePickerRef = React.useRef<HTMLDivElement>(null);

  const [currTab, setCurrTab] = React.useState(state.travelType);
  const [originState, setOriginState] = React.useState({
    city_name: state.origin_city,
    airport_name: state.origin,
    country_name: state.originCountry,
  });
  const [destinationState, setDestinationState] = React.useState({
    city_name: state.destination_city,
    airport_name: state.destination,
    country_name: state.destinationCountry,
  });
  const [classData, setClassData] = React.useState(state?.passengers);
  const [mobileNonStopOnly, setMobileNonStopOnly] = React.useState(false);
  const [fromDate, setFromDate] = React.useState<Date>(() => {
    const parsedDate = parseStateDate(state?.date);
    if (parsedDate) {
      return parsedDate;
    }
    return new Date();
  });
  const [returnDate, setReturnDate] = React.useState<Date>(() => {
    const parsedDate = parseStateDate(state?.rt_date);
    if (parsedDate) {
      return parsedDate;
    }
    return new Date();
  });
  // const userInput = useSelector((state: any) => state.userInputs);
  const onChangeOrigin = (
    city_name: string,
    airport_name: string,
    country_name: string,
  ) => {
    setOriginState({ city_name, airport_name, country_name });
    // if (country_name != state.destinationCountry) {
    //   dispatch(
    //     updateReviewData({
    //       travelMode: 'IN',
    //       trip_type: 'IN',
    //       travelType: 'OW',
    //       tripType: 'OW',
    //     }),
    //   );
    //   if (state.travelType == 'RT') {
    //     dispatch(
    //       updateReviewData({
    //         tripType: 'INRT',
    //         travelMode: 'IN',
    //         travelType: 'RT',
    //       }),
    //     );
    //   }
    // } else {
    //   dispatch(
    //     updateReviewData({
    //       travelMode: 'DO',
    //       trip_type: 'DO',
    //       travelType: 'OW',
    //       tripType: 'OW',
    //     }),
    //   );
    //   if (state.travelType == 'RT') {
    //     dispatch(
    //       updateReviewData({
    //         travelMode: 'DO',
    //         travelType: 'RT',
    //         tripType: 'OW',
    //       }),
    //     );
    //   }
    // }
    // Only auto-trigger destination picker if a city was selected (not during typing)
    if (airport_name) {
      destinationPickerRef.current?.click();
    }
  };
  const onChangeDestination = (
    city_name: string,
    airport_name: string,
    country_name: string,
  ) => {
    setDestinationState({ city_name, airport_name, country_name });
    // if (state.originCountry != country_name) {
    //   dispatch(
    //     updateReviewData({
    //       travelMode: 'IN',
    //       trip_type: 'IN',
    //       travelType: 'OW',
    //       tripType: 'OW',
    //     }),
    //   );
    //   if (state.travelType == 'RT') {
    //     dispatch(
    //       updateReviewData({
    //         tripType: 'INRT',
    //         travelMode: 'IN',
    //         travelType: 'RT',
    //       }),
    //     );
    //   }
    // } else {
    //   dispatch(
    //     updateReviewData({
    //       travelMode: 'DO',
    //       trip_type: 'DO',
    //       travelType: 'OW',
    //       tripType: 'OW',
    //     }),
    //   );
    //   if (state.travelType == 'RT') {
    //     dispatch(updateReviewData({ travelType: 'RT', travelMode: 'DO' }));
    //   }
    // }
    // Only auto-trigger from date picker if a city was selected (not during typing)
    if (airport_name) {
      fromDatePickerRef.current?.click();
    }
  };

  const onChangeFromDate = (date: Date) => {
    setFromDate(date);
    dispatch(updateField({ field: 'date', value: date }));
    // Auto-trigger return date picker if round trip
    if (currTab === 'RT') {
      returnDatePickerRef.current?.click();
    }
  };
  const onChangeReturnDate = (date: Date) => {
    setReturnDate(date);
    dispatch(updateField({ field: 'rt_date', value: date }));
  };
  const onChangeTripTab = (type: 'OW' | 'RT') => {
    setCurrTab(type);
    dispatch(updateField({ field: 'travelType', value: type }));
    // if (type === 'RT') {
    //   dispatch(updateField({ field: 'rt_date', value:  }));
    // }
  };
  const [shouldTriggerSearch, setShouldTriggerSearch] = React.useState(false);

  const initiateSearch = () => {
    // Reset any existing filters before new search
    dispatch(resetFilter());

    // Set loading state to true to show loader
    dispatch(setIsLoading(true));

    // Check if international flight
    // Update state based on origin/destination countries
    const updatedState =
      state.originCountry !== state.destinationCountry
        ? {
            tripType: state.travelType === 'RT' ? 'INRT' : 'OW',
            travelMode: 'IN',
            trip_type: 'IN',
          }
        : {
            tripType: 'OW',
            travelMode: 'DO',
            trip_type: 'DO',
          };

    // Update Redux state
    dispatch(updateReviewData(updatedState));
    dispatch(storeData({ data: [], field: 'data' }));

    // Set flag to trigger search after state update
    setShouldTriggerSearch(true);
  };
  const checkbox =
    config.corporateName === 'Tripbng'
      ? [
          { id: 'Regular', value: 'Regular' },
          { id: 'Senior_Citizen', value: 'Senior Citizen' },
        ]
      : [
          { id: 'Direct_Flight', value: 'Direct Flight'},
          { id: 'Regular', value: 'Regular' },
          { id: 'Student', value: 'Student' },
          { id: 'Senior_Citizen', value: 'Senior Citizen' },
          { id: 'Armed_Forces', value: 'Armed Forces' },
          { id: 'Doctors_Nurses', value: 'Doctors & Nurses' },
        ];
  React.useEffect(() => {
    sessionStorage?.removeItem('seatData');
    sessionStorage?.removeItem('ssrInfoData');
    dispatch(updatePassenger([]));
    setCurrTab(state.travelType);
    if (trackApiCall.current === false && state.destination != '') {
      trackApiCall.current = true;
      performFlightSearch(state.travelType);
    }
  }, [state.travelType]);

  useEffect(() => {
    if (!isLoading) {
      dispatch(
        storeData({ data: searchResults?.outBoundFlight?.data, field: 'data' }),
      );
      if (
        searchResults?.returnFlight?.data &&
        searchResults?.returnFlight?.data?.length > 0 &&
        state?.travelMode == 'DO' &&
        state?.travelType == 'RT'
      ) {
        dispatch(
          storeReturnData({
            data: searchResults?.returnFlight?.data,
            field: 'returnData',
          }),
        );
      }
    }
  }, [isLoading, searchResults]);

  useEffect(() => {
    dispatch(resetFilter());
    const parsedDate = parseStateDate(state.date);
    if (parsedDate) {
      setFromDate(parsedDate);
    } else if (state.date) {
      console.error('Invalid state.date:', state.date);
    }
  }, [state.date, dispatch]);

  useEffect(() => {
    const parsedDate = parseStateDate(state.rt_date);
    if (parsedDate) {
      setReturnDate(parsedDate);
    } else if (state.rt_date) {
      console.error('Invalid state.rt_date:', state.rt_date);
    }
  }, [state.rt_date]);

  // Effect to trigger flight search after state updates
  useEffect(() => {
    if (shouldTriggerSearch) {
      performFlightSearch(currTab);
      setShouldTriggerSearch(false);
      // update the state in session storage for maintain once reload browser
      sessionStorage.setItem('reqData', JSON.stringify(state));
    }
  }, [shouldTriggerSearch]);

  const [showSearchPopup, setShowSearchPopup] = React.useState(false);
  const [showFilterPopup, setShowFilterPopup] = React.useState(false);

  const handleCheckboxChange = (checked: boolean | string, value: string) => {
    if (checked) {
      dispatch(updateFareType([value]));
    } else {
      dispatch(
        updateFareType(state.fareType.filter((fare: string) => fare !== value)),
      );
    }
  };

  const clearOrigin = () => {
    setOriginState({
      city_name: '',
      airport_name: '',
      country_name: '',
    });
    dispatch(updateField({ field: 'origin', value: '' }));
    dispatch(updateField({ field: 'originCountry', value: '' }));
  };

  const clearDestination = () => {
    setDestinationState({
      city_name: '',
      airport_name: '',
      country_name: '',
    });
    dispatch(updateField({ field: 'destination', value: '' }));
    dispatch(updateField({ field: 'destinationCountry', value: '' }));
  };

  const swapLocations = () => {
    // Store current states
    const tempOrigin = { ...originState };
    const tempDestination = { ...destinationState };

    // Update local states
    setOriginState({
      city_name: tempDestination.city_name,
      airport_name: tempDestination.airport_name,
      country_name: tempDestination.country_name,
    });
    setDestinationState({
      city_name: tempOrigin.city_name,
      airport_name: tempOrigin.airport_name,
      country_name: tempOrigin.country_name,
    });

    // Update Redux store with type assertions
    dispatch(
      updateField({ field: 'origin', value: tempDestination.airport_name }),
    );
    dispatch(
      updateField({ field: 'destination', value: tempOrigin.airport_name }),
    );
    dispatch(
      updateField({
        field: 'originCountry',
        value: tempDestination.country_name,
      }),
    );
    dispatch(
      updateField({
        field: 'destinationCountry',
        value: tempOrigin.country_name,
      }),
    );
    dispatch(
      updateField({ field: 'origin_city', value: tempDestination.city_name }),
    );
    dispatch(
      updateField({ field: 'destination_city', value: tempOrigin.city_name }),
    );

    // Update travel mode based on countries
    if (tempDestination.country_name !== tempOrigin.country_name) {
      dispatch(
        updateReviewData({
          travelMode: 'IN',
          trip_type: 'IN',
          travelType: state.travelType,
          tripType: state.travelType === 'RT' ? 'INRT' : 'OW',
        }),
      );
    } else {
      dispatch(
        updateReviewData({
          travelMode: 'DO',
          trip_type: 'DO',
          travelType: state.travelType,
          tripType: 'OW',
        }),
      );
    }

    // Clear existing search results
    dispatch(storeData({ data: [], field: 'data' }));
    if (state.travelType === 'RT') {
      dispatch(storeReturnData({ data: [], field: 'returnData' }));
    }
  };

  return (
    <>
      {/* Full-screen loader */}
      {isLoading && (
        <div className="fixed inset-0 z-50">
          <FlightLoader />
        </div>
      )}

      <div className={`w-full border-t-2 border-gray-200`}>
        {/* Mobile Search Button */}
        <div className="bg-primary px-4 py-2 sm:hidden">
          <div className="flex items-center gap-3">
            <Button
              onClick={() => setShowSearchPopup(true)}
              className="flex h-fit w-full items-center justify-between rounded-lg bg-white px-4 py-3 text-primary hover:bg-white/90"
            >
              <div
                className={`flex flex-wrap justify-center space-y-1 ${state?.travelType === 'RT' ? 'flex-col' : 'flex-row items-center gap-2'}`}
              >
                {/* Outbound Flight */}
                <div className="flex flex-row flex-wrap items-start space-x-2">
                  <div className="flex flex-col flex-wrap">
                    <div className="flex items-center gap-1">
                      <span className="text-sm font-medium">
                        {state.origin} → {state.destination}
                      </span>
                    </div>
                    <span className="text-xs text-gray-500">
                      {format(fromDate, 'MMM dd, EEE')}
                    </span>
                  </div>

                  {/* Return Flight - Only show if Round Trip */}
                  {currTab === 'RT' && (
                    <div className="flex flex-col">
                      <div className="flex items-center gap-1">
                        <span className="text-sm font-medium">
                          {state.destination} → {state.origin}
                        </span>
                      </div>
                      <span className="text-xs text-gray-500">
                        {format(returnDate, 'MMM dd, EEE')}
                      </span>
                    </div>
                  )}
                </div>

                {/* Traveler Info */}
                <span className="text-xs text-gray-500">
                  {Number(classData?.adult) +
                    Number(classData?.child) +
                    Number(classData?.infant) || 1}{' '}
                  Traveler{(classData?.adult || 1) > 1 ? 's' : ''} •{' '}
                  {classData?.cabin || 'Economy'}
                </span>
              </div>
              <Edit2 className="h-4 w-4 flex-shrink-0" />
            </Button>
            <Button
              onClick={() => setShowFilterPopup(true)}
              className="relative flex h-10 w-10 items-center justify-center rounded-full bg-white p-3 text-primary shadow-none hover:bg-white/90"
            >
              <IoFunnel size={24} />
              {mobileNonStopOnly && (
                <span className="absolute -right-1 -top-1 flex h-4 w-4 items-center justify-center rounded-full bg-zinc-900 text-[10px] text-white">
                  1
                </span>
              )}
            </Button>
          </div>
        </div>
        <div className="px-4 py-3 sm:hidden">
          <Button
            variant="outline"
            onClick={() => setMobileNonStopOnly((prev) => !prev)}
            className={`h-8 rounded-md border px-3 text-sm font-medium ${
              mobileNonStopOnly
                ? 'border-tabBackground bg-primary text-white hover:bg-primary/90 hover:text-white'
                : 'border-primary bg-white text-primary hover:bg-primary/5'
            }`}
          >
            Non-Stop
          </Button>
        </div>

        {/* Desktop View */}
        <div className="text-text-primary border-border-default hidden border-b bg-white py-2.5 sm:block">
          <div
            className={`mx-auto flex flex-wrap justify-center ${config.corporateName === '' ? 'w-[90%]' : 'w-[1200px]'}`}
          >
            <Tabs
              className="w-full"
              onValueChange={(text: string) =>
                onChangeTripTab(text as 'OW' | 'RT')
              }
              value={state.travelType}
            >
              <TabsList className="mx-auto flex justify-start p-0">
                <TabsTrigger
                  value="OW"
                  className={`rounded-2xl text-white ${currTab === 'OW' ? 'bg-tabBackground text-white' : 'text-dark'} sm:px-2 lg:px-5 lg:text-xs`}
                >
                  One Way
                </TabsTrigger>
                <TabsTrigger
                  value="RT"
                  className={`rounded-2xl text-white ${currTab === 'RT' ? 'bg-tabBackground text-white' : 'text-dark'} sm:px-2 lg:px-5 lg:text-xs`}
                >
                  Round Trip
                </TabsTrigger>
                {/* <TabsTrigger
                  value="MC"
                  className={`rounded-2xl text-white ${currTab === 'MC' ? 'bg-white text-primary' : ''} sm:px-2 lg:px-5 lg:text-xs`}
                >
                  Multi City
                </TabsTrigger> */}
              </TabsList>
              <div className="mt-3 flex w-full items-end gap-2.5">
                <CityPicker
                  type="From"
                  className="w-1/6"
                  state={originState}
                  setState={onChangeOrigin}
                >
                  <div ref={originPickerRef} onClick={clearOrigin}>
                    <TriggerComponent
                      className="w-full"
                      title="From"
                      value={{
                        countryName: state.originCountry,
                        cityName: state.origin,
                      }}
                    />
                  </div>
                </CityPicker>

                <ArrowLeftRight
                  size={24}
                  strokeWidth={1.3}
                  className="mb-1.5 cursor-pointer"
                  onClick={swapLocations}
                />

                <CityPicker
                  type="To"
                  state={destinationState}
                  className="w-1/6"
                  setState={onChangeDestination}
                >
                  <div ref={destinationPickerRef} onClick={clearDestination}>
                    <TriggerComponent
                      className="w-full"
                      title="To"
                      value={{
                        countryName: state.destinationCountry,
                        cityName: state.destination,
                      }}
                    />
                  </div>
                </CityPicker>
                <DatePicker
                  title="From Date"
                  disabled={false}
                  type="FromDate"
                  setDate={onChangeFromDate}
                  selectedDate={state.date}
                  className="w-1/6"
                  disableDates={{
                    min: new Date(),
                    max:
                      state.travelType === 'RT' && state?.rt_date
                        ? new Date(state?.rt_date)
                        : addDays(new Date(), 750),
                  }}
                >
                  <div ref={fromDatePickerRef}>
                    <TriggerComponent
                      title="From Date"
                      className="w-full"
                      value={state.date}
                    />
                  </div>
                </DatePicker>
                {currTab === 'RT' && (
                  <DatePicker
                    title="Return Date"
                    disabled={currTab === 'OW'}
                    type="ToDate"
                    setDate={onChangeReturnDate}
                    selectedDate={returnDate}
                    disableDates={{
                      min: new Date(state?.date),
                      max:
                        state.travelType === 'RT' && state?.rt_date
                          ? addDays(new Date(state?.rt_date), 750)
                          : new Date(state?.rt_date),
                    }}
                  >
                    <div ref={returnDatePickerRef}>
                      <TriggerComponent
                        title="Return Date"
                        className="w-full"
                        value={formatDateForDisplay(returnDate)}
                      />
                    </div>
                  </DatePicker>
                )}

                <ClassPicker setData={setClassData}>
                  <ClassPickerTrigger
                    className="1/5"
                    title={'Travelers and Class'}
                    data={classData}
                  />
                </ClassPicker>
                <Button
                  variant="default"
                  size="lg"
                  className="h-9 w-1/6 bg-tabBackground text-white"
                  onClick={initiateSearch}
                >
                  <h4>Update Search</h4>
                </Button>
              </div>

              <div className="item-center mt-4 flex gap-4">
                {checkbox.map((check) => {
                  return (
                    <div
                      key={check.id}
                      className="mt-2.5 flex items-center space-x-2"
                    >
                      <Checkbox
                        checked={state.fareType.includes(check.id)}
                        id={check.id}
                        className="text-white"
                        onCheckedChange={(checked) => {
                          if (checked) {
                            document
                              .querySelectorAll('input[type="checkbox"]')
                              .forEach((checkbox) => {
                                if (checkbox.id !== check.id) {
                                  (checkbox as HTMLInputElement).checked =
                                    false;
                                }
                              });
                          }
                          handleCheckboxChange(checked, check.id);
                        }}
                      />
                      <Label
                        htmlFor={check.id}
                        className="text-text-tertiary cursor-pointer text-xs font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                      >
                        {check.value}
                      </Label>
                    </div>
                  );
                })}
              </div>
            </Tabs>
          </div>
        </div>

        {/* Mobile Search Popup */}
        <Dialog open={showSearchPopup} onOpenChange={setShowSearchPopup}>
          <DialogContent className="max-h-max max-w-[95%] rounded-lg p-4 sm:hidden">
            <DialogHeader>
              <DialogTitle className="space-y-0 text-lg font-semibold">
                Modify Search
              </DialogTitle>
            </DialogHeader>

            <div className="mt-2 flex flex-col gap-4">
              <Tabs
                className="w-full"
                onValueChange={(text: string) =>
                  onChangeTripTab(text as 'OW' | 'RT')
                }
                value={state.travelType}
              >
                <TabsList className="mb-4 flex w-full justify-center">
                  <TabsTrigger
                    value="OW"
                    className={`flex-1 rounded-2xl ${currTab === 'OW' ? 'text-white data-[state=active]:bg-primary' : ''}`}
                  >
                    One Way
                  </TabsTrigger>
                  <TabsTrigger
                    value="RT"
                    className={`flex-1 rounded-2xl ${currTab === 'RT' ? 'text-white data-[state=active]:bg-primary' : ''}`}
                  >
                    Round Trip
                  </TabsTrigger>
                </TabsList>

                <div className="space-y-4">
                  <div className="flex flex-col gap-2">
                    <CityPicker
                      type="From"
                      className="w-full"
                      state={originState}
                      setState={onChangeOrigin}
                    >
                      <div ref={originPickerRef} onClick={clearOrigin}>
                        <TriggerComponent
                          className="w-full"
                          title="From"
                          value={{
                            countryName: state.originCountry,
                            cityName: state.origin,
                          }}
                        />
                      </div>
                    </CityPicker>
                  </div>

                  <div className="flex flex-col gap-2">
                    <CityPicker
                      type="To"
                      state={destinationState}
                      className="w-full"
                      setState={onChangeDestination}
                    >
                      <div
                        ref={destinationPickerRef}
                        onClick={clearDestination}
                      >
                        <TriggerComponent
                          className="w-full"
                          title="To"
                          value={{
                            countryName: state.destinationCountry,
                            cityName: state.destination,
                          }}
                        />
                      </div>
                    </CityPicker>
                  </div>

                  <div className="flex flex-col gap-2">
                    <DatePicker
                      title="From Date"
                      disabled={false}
                      type="FromDate"
                      setDate={onChangeFromDate}
                      selectedDate={state.date}
                      className="w-full"
                      disableDates={{
                        min: new Date(),
                        max:
                          state.travelType === 'RT' && state?.rt_date
                            ? new Date(state?.rt_date)
                            : addDays(new Date(), 750),
                      }}
                    >
                      <div ref={fromDatePickerRef}>
                        <TriggerComponent
                          title="From Date"
                          className="w-full"
                          value={state.date}
                        />
                      </div>
                    </DatePicker>
                  </div>

                  {currTab === 'RT' && (
                    <div className="flex flex-col gap-2">
                      <DatePicker
                        title="Return Date"
                        type="ToDate"
                        disabled={false}
                        setDate={onChangeReturnDate}
                        selectedDate={state.rt_date}
                        className="w-full"
                        disableDates={{
                          min: new Date(state?.date),
                          max: addDays(new Date(), 750),
                        }}
                      >
                        <div ref={returnDatePickerRef}>
                          <TriggerComponent
                            title="Return Date"
                            className="w-full"
                            value={state.rt_date}
                          />
                        </div>
                      </DatePicker>
                    </div>
                  )}

                  <div className="flex flex-col gap-2">
                    <ClassPicker setData={setClassData}>
                      <ClassPickerTrigger
                        className="w-full"
                        title={'Travelers and Class'}
                        data={classData}
                      />
                    </ClassPicker>
                  </div>

                  <div className="flex flex-wrap gap-2">
                    {checkbox.map((check) => (
                      <div
                        key={check.id}
                        className="flex items-center space-x-2"
                      >
                        <Checkbox
                          checked={state.fareType.includes(check.id)}
                          id={check.id}
                          className="border-text-tertiary h-3 w-3 border data-[state=checked]:bg-tertiary dark:data-[state=checked]:bg-tertiary sm:h-4 sm:w-4"
                          onCheckedChange={(checked) => {
                            if (checked) {
                              document
                                .querySelectorAll('input[type="checkbox"]')
                                .forEach((checkbox) => {
                                  if (checkbox.id !== check.id) {
                                    (checkbox as HTMLInputElement).checked =
                                      false;
                                  }
                                });
                            }
                            handleCheckboxChange(checked, check.id);
                          }}
                        />
                        <Label htmlFor={check.id} className="text-xs">
                          {check.value}
                        </Label>
                      </div>
                    ))}
                  </div>
                </div>
              </Tabs>

              <DialogFooter className="mt-auto">
                <Button
                  type="button"
                  onClick={() => {
                    initiateSearch();
                    setShowSearchPopup(false);
                  }}
                  className="hover:bg-primary/90 w-full bg-primary text-white"
                >
                  Search Flights
                </Button>
              </DialogFooter>
            </div>
          </DialogContent>
        </Dialog>

        {/* Filter Section */}
        <div className="mx-auto mt-5 flex gap-6 rounded-2xl sm:w-[1200px]">
          {/* Desktop Filter */}
          <div className="hidden w-1/4 sm:block">
            <Filter isLoading={isLoading} data={searchResults} />
          </div>

          {/* Mobile Filter Popup */}
          <Dialog open={showFilterPopup} onOpenChange={setShowFilterPopup}>
            <DialogContent className="h-[90vh] max-w-[90%] overflow-y-auto rounded-lg p-3 sm:hidden">
              <DialogHeader className="pb-2">
                <DialogTitle className="flex items-center gap-2 text-base font-semibold">
                  <IoFunnel className="h-4 w-4" />
                  Filters
                </DialogTitle>
              </DialogHeader>

              <div className="-mx-3 flex-1 overflow-hidden px-3">
                <Filter isLoading={isLoading} data={searchResults} />
              </div>

              <DialogFooter className="mt-2 flex gap-3">
                <Button
                  variant="outline"
                  onClick={() => setShowFilterPopup(false)}
                  className="flex-1"
                >
                  Close
                </Button>
              </DialogFooter>
            </DialogContent>
          </Dialog>

          <div className="relative h-full w-full rounded-2xl">
            <div className="my-3 hidden sm:block">
              {state?.travelType === 'OW' && (
                <FareCalender callback={initiateSearch} />
              )}
            </div>
            {!isLoading && (
              <>
                <div className="flex flex-col sm:hidden">
                  {state?.travelType === 'RT' && (
                    <Tabs className="w-full" defaultValue="OUT_BOUND">
                      {state?.travelMode === 'DO' && (
                        <TabsList className="mb-3 grid w-full grid-cols-2">
                          <TabsTrigger
                            value="OUT_BOUND"
                            className="flex items-center justify-center gap-4 rounded-lg data-[state=active]:bg-primary data-[state=active]:text-white"
                          >
                            <span className="h-4 w-4 flex-shrink-0">
                              <FlightUpIcon className="h-6 w-6" />
                            </span>
                            <span className="line-clamp-1">Onward</span>
                          </TabsTrigger>
                          <TabsTrigger
                            value="IN_BOUND"
                            className="flex items-center justify-center gap-4 rounded-lg data-[state=active]:bg-primary data-[state=active]:text-white"
                          >
                            <span className="h-4 w-4 flex-shrink-0">
                              <FlightDownIcon className="h-6 w-6" />
                            </span>
                            <span className="line-clamp-1">Return</span>
                          </TabsTrigger>
                        </TabsList>
                      )}

                      <TabsContent value="OUT_BOUND">
                        <FlightList
                          data={searchResults?.outBoundFlight}
                          type="OUT_BOUND"
                          title={`Onward in ${searchResults?.outBoundFlight?.data?.[0]?.flightInfo?.[0]?.departure_city_name || state.origin_city || 'Unknown'} to ${searchResults?.outBoundFlight?.data?.[0]?.flightInfo?.[0]?.arrival_city_name || state.destination_city || 'Unknown'} - ${state?.date ? format(state.date, 'eee, d MMMM yyyy') : 'Unknown Date'}`}
                          icon={''}
                        nonStopOnly={mobileNonStopOnly}
                        />
                      </TabsContent>
                      <TabsContent value="IN_BOUND">
                        {state.travelMode === 'DO' && (
                          <FlightList
                            data={searchResults?.returnFlight}
                            type="RETURN"
                            title={`Return in ${searchResults?.returnFlight?.data?.[0]?.flightInfo?.[0]?.departure_city_name || state.destination_city || 'Unknown'} to ${searchResults?.returnFlight?.data?.[0]?.flightInfo?.[0]?.arrival_city_name || state.origin_city || 'Unknown'} - ${state?.rt_date ? format(state.rt_date, 'eee, d MMMM yyyy') : 'Unknown Date'}`}
                            icon={''}
                            nonStopOnly={mobileNonStopOnly}
                          />
                        )}
                      </TabsContent>
                    </Tabs>
                  )}
                </div>
                <div
                  className={`${
                    state?.tripType === 'INRT'
                      ? 'hidden gap-4 sm:grid sm:grid-cols-1 sm:items-start'
                      : state?.travelType === 'RT'
                        ? 'hidden gap-4 sm:grid sm:grid-cols-2 sm:items-start'
                        : 'flex flex-col'
                  }`}
                >
                  {state?.travelType === 'OW' ||
                  (state.tripType == 'INRT' &&
                    searchResults?.outBoundFlight?.data?.length > 0) ||
                  (state?.travelType == 'RT' &&
                    state.travelMode == 'DO' &&
                    searchResults?.outBoundFlight?.data?.length > 0 &&
                    searchResults?.returnFlight?.data?.length > 0) ? (
                    <>
                      <FlightList
                        data={searchResults?.outBoundFlight}
                        type="OUT_BOUND"
                        title={`Onward in ${searchResults?.outBoundFlight?.data?.[0]?.flightInfo?.[0]?.departure_city_name || state.origin_city || 'Unknown'} to ${searchResults?.outBoundFlight?.data?.[0]?.flightInfo?.[0]?.arrival_city_name || state.destination_city || 'Unknown'} - ${state?.date ? format(state.date, 'eee, d MMMM yyyy') : 'Unknown Date'}`}
                        icon={<FlightUpIcon className="h-6 w-6" />}
                        nonStopOnly={mobileNonStopOnly}
                      />
                      {state?.travelType === 'RT' &&
                        state.travelMode === 'DO' && (
                          <FlightList
                            data={searchResults?.returnFlight}
                            type="RETURN"
                            title={`Return in ${searchResults?.returnFlight?.data?.[0]?.flightInfo?.[0]?.departure_city_name || state.destination_city || 'Unknown'} to ${searchResults?.returnFlight?.data?.[0]?.flightInfo?.[0]?.arrival_city_name || state.origin_city || 'Unknown'} - ${state?.rt_date ? format(state.rt_date, 'eee, d MMMM yyyy') : 'Unknown Date'}`}
                            icon={<FlightDownIcon className="h-6 w-6" />}
                            nonStopOnly={mobileNonStopOnly}
                          />
                        )}
                    </>
                  ) : (
                    <div className="h-100 flex w-full flex-col items-center justify-center">
                      <span>No flights found</span>
                    </div>
                  )}
                </div>
                {searchResults?.outBoundFlight?.data?.length > 0 &&
                  searchResults?.returnFlight?.data?.length > 0 &&
                  state?.travelType === 'RT' &&
                  state?.travelMode === 'DO' &&
                  !isLoading && <SelectedFlightInfo />}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

function parseStateDate(
  dateValue: Date | string | null | undefined,
): Date | null {
  if (!dateValue) return null;

  if (dateValue instanceof Date) {
    return isValid(dateValue) ? dateValue : null;
  }

  if (typeof dateValue !== 'string') return null;

  // Try ISO-like inputs first.
  const isoParsed = parseISO(dateValue);
  if (isValid(isoParsed)) return isoParsed;

  // Support display format used in state in some flows: "22, Mar 2026"
  const displayParsed = parse(dateValue, 'dd, MMM yyyy', new Date());
  if (isValid(displayParsed)) return displayParsed;

  // Last fallback for browser-parseable strings.
  const nativeParsed = new Date(dateValue);
  return isValid(nativeParsed) ? nativeParsed : null;
}

// Helper function to safely format dates for display
const formatDateForDisplay = (
  dateValue: Date | string | null | undefined,
): string => {
  try {
    if (!dateValue) return '';
    const date = parseStateDate(dateValue);
    if (!date) return '';

    if (!isValid(date)) return '';

    return format(date, 'dd, MMM yyyy');
  } catch (error) {
    console.warn('Date formatting error:', error);
    return '';
  }
};

export default FlightListing;

const TriggerComponent = ({
  title,
  value,
  className,
  titleClassName,
}: {
  title: string;
  value: { cityName: string; countryName: string } | string | Date;
  className: string;
  titleClassName?: string;
}) => {
  return (
    <div className={className}>
      <span className={`text-xs ${titleClassName}`}>{title}</span>
      <Input
        readOnly
        value={
          title === 'From Date' || title === 'Return Date'
            ? formatDateForDisplay(value as Date | string | null | undefined)
            : `${(value as { countryName: string; cityName: string }).cityName} ${(value as { countryName: string; cityName: string }).countryName}`
        }
        className="placeholder:text-light h-9 rounded-lg bg-transparent focus:outline-none"
      ></Input>
    </div>
  );
};

const ClassPickerTrigger = ({
  title,
  data,
  className,
}: {
  title: string;
  data: { adult: number; child: number; infant: number; cabin: string };
  className: string;
}) => {
  let text = '';
  if (data?.adult > 0) {
    text += `${data?.adult} Adult,`;
  }
  if (data?.child > 0) {
    text += `${data?.child} Child,`;
  }
  if (data?.infant > 0) {
    text += `${data?.infant} Infant `;
  }
  if (data?.cabin) {
    text += `${data?.cabin}`;
  }
  return (
    <div className={className}>
      <span className="text-xs">{title}</span>
      <Input
        value={text}
        readOnly
        className="placeholder:text-light h-9 rounded-lg border bg-transparent focus:outline-none"
      ></Input>
    </div>
  );
};
